import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonContent, IonHeader, IonToolbar, IonButton, IonBackButton, IonFooter, IonLabel, ModalController, ViewDidEnter, IonButtons } from '@ionic/angular/standalone';
import { Panel } from 'primeng/panel';
import { ConfettiComponent } from 'src/app/confetti/confetti.component';
import { LocalData, Question, Training } from 'src/app/app.types';
import { UtilsService } from 'src/app/utils.service';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/api.service';
import { AuthService, TempoUser } from 'src/app/auth.service';
import { AuthComponent } from 'src/app/components/auth/auth.component';
import { Subscription } from 'rxjs';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.page.html',
  styleUrls: ['./quiz.page.scss'],
  standalone: true,
  imports: [IonLabel, IonFooter, IonBackButton,
    CommonModule,
    FormsModule,
    IonContent,
    Panel,
    ConfettiComponent,
    IonHeader,
    IonToolbar,
    IonBackButton,
    IonButton, IonButtons],
})
export class QuizPage implements OnInit, ViewDidEnter, OnDestroy {

  t: Training
  ld: LocalData
  //tsub!: Subscription
  qindex = 0
  q!: Question
  ended = false

  ready = false

  user: TempoUser
  qelapsed = "00:00"

  private utils = inject(UtilsService)

  timerSub: Subscription

  constructor(
    private api: ApiService,
    private modalController: ModalController
  ) { }

  ngOnDestroy() {
    if (this.timerSub) this.timerSub.unsubscribe()
  }

  ionViewDidEnter() {
    if (!this.ended && this.t.race_active) {
      if (!this.ld.quizTimeStart) {
        this.ld.quizTimeStart = Math.round(Date.now() / 1000)
      }

      if (!this.ld.quizTimeEnd) {
        this.timerSub = this.utils.timerStateChange$.subscribe((time) => {
          const diff = time - this.ld.quizTimeStart
          this.qelapsed = this.api.readableMinSec(diff)
        })
        this.utils.startTimer()
      }

    }
  }

  async ngOnInit() {


    this.ld = await this.utils.getLocalData(this.t, this.user?.uid)
    const tquests = await this.api.getTrainingQuest(this.t.tid)
    this.t.questions = tquests.questions

    for (const q of this.t.questions) {
      q.responses = this.shuffleArray(q.responses)
    }

    this.q = this.t.questions[0]

    this.ready = true
  }

  setUserResponse(e: MouseEvent, index: number, qid: number, rid: number) {
    this.ld.userData.responses[index] = {
      qid: qid,
      rid: rid
    }
    this.utils.saveLocalData(this.t.tid!, this.user?.uid, this.ld)
  }

  isDev() {
    return !environment.production
  }

  getSeverity(rid?: number) {
    if(!rid) return "light"
    const urid = this.ld.userData.responses.filter((ur) => ur.rid === rid)
    if (urid.length > 0) {
      return "dark"
    }
    return "light"
  }

  nextReady(i: number) {
    return !this.ld.userData.responses[i]
  }

  hasPrev(index: number) {
    return index > 0
  }

  activatePrevious(activateCallback: any, index: number) {
    activateCallback(this.t.questions![index - 1].qid)
  }

  async nextQuest() {
    await this.utils.saveLocalData(this.t.tid, this.user?.uid, this.ld)
    const next = this.qindex + 1
    if (next < this.t.questions!.length) {
      this.qindex = next
      this.q = this.t.questions![next]
    } else {
      this.ended = true
      if (!this.ld.quizTimeEnd) {
        this.ld.quizTimeEnd = Math.round(Date.now() / 1000)
        this.utils.stopTimer()
        await this.utils.saveLocalData(this.t.tid, this.user?.uid, this.ld)
      }



      if (!this.user) {

        const modal = await this.modalController.create({
          component: AuthComponent,
          componentProps: {
            fromTraining: true
          }
        })
        await modal.present()
        const { data } = await modal.onDidDismiss()
        if (data.user) {

          console.log("localData", JSON.stringify(this.ld, null, 2))
          await this.utils.saveLocalData(this.t.tid, data.user.uid, this.ld)

          this.user = data.user
          console.log("User is set in quiz page")
        }

      }
    }
  }

  prevQuest() {
    this.qindex -= 1
    this.q = this.t.questions![this.qindex]
  }

  activateNext(activateCallback: any, index: number) {
    if (index > this.t.questions!.length) {
      // End
      activateCallback(0)
    } else {
      activateCallback(this.t.questions![index + 1].qid)
    }
  }

  shuffleArray<T>(array: T[]): T[] {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }
}
